<app-menu></app-menu>
<div style="height: 100%; box-sizing: border-box;">
    <div class='center' *ngIf="isLoading">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  <mat-card style="height: 100%; box-sizing: border-box; padding:0">
      <file-manager *ngIf="!isLoading" [fileElements]="fileElements | async" [path]="currentPath" [canNavigateUp]="canNavigateUp"
      (elementRemoved)="removeElement($event)" (navigatedDown)="navigateToFolder($event)" (navigatedUp)="navigateUp()"></file-manager>
  </mat-card>
</div>
